import { findAgentEntry, fixedModeName } from './agent-picker-blocks';
import { useAgentPickerQuery } from './agent-picker.query';
import { ModelLogo } from './model-logo';

/** The selected chat mode as the picker's trigger shows it: logo, name and prompt version */
export const AgentModeLabel = ({ mode }: { mode: string }) => {
  const { data: entries } = useAgentPickerQuery();
  const entry = findAgentEntry(entries, mode);
  if (!entry)
    return <span className="min-w-0 truncate">{fixedModeName(mode)}</span>;

  return (
    <>
      <ModelLogo company={entry.company} className="size-3.5 shrink-0" />
      <span className="min-w-0 truncate">{entry.name}</span>
      {entry.version && (
        <span className="shrink-0 text-xs text-foreground-muted">
          V{entry.version}
        </span>
      )}
    </>
  );
};
